import { ENABLE_NEW_NAM_COMMISSION_MODEL_WEB_RETAILER_230420 } from "@faire/web-api--source/indigofair/settings/ENABLE_NEW_NAM_COMMISSION_MODEL_WEB_RETAILER_230420";

import { getSettingValueAndAssign } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";

export const getSettingEnableNewNAMCommissionModelWebRetailer = (): boolean =>
  getSettingValueAndAssign(
    ENABLE_NEW_NAM_COMMISSION_MODEL_WEB_RETAILER_230420,
    false
  );
